import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// eslint-disable-next-line import/extensions
import env from '@tencent/vft-common/env';
import { mapState } from 'vuex';
import { buildUrl } from '@tencent/vft-common/url';
import { PACKAHE_PTAG } from '@/config';
import Game from '../game/game.vue';
export default {
  name: 'Pay',
  components: {
    Game: Game
  },
  settingKey: '套餐开通区域',
  data: function data() {
    return {
      tab: env.isQQSports ? 'svip' : 'vip',
      tabList: [{
        type: 'vip',
        bg: 'https://puui.qpic.cn/media_img/lena/PICj8dq72_1503_1013/0'
      }, {
        type: 'svip',
        bg: 'http://puui.qpic.cn/media_img/lena/PICju8v48_1503_1013/0'
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['openStatus'])), {}, {
    isVipTab: function isVipTab() {
      return this.tab === 'vip';
    },
    套餐背景图: function 套餐背景图() {
      var _this$setting$开通套餐模块$ = this.setting.开通套餐模块.套餐背景图,
          vip = _this$setting$开通套餐模块$.vip,
          svip = _this$setting$开通套餐模块$.svip;
      return this.isVipTab ? vip : svip;
    },
    按钮背景图: function 按钮背景图() {
      return this.setting.开通套餐模块.按钮背景图;
    },
    // 当前套餐模块
    curMods: function curMods() {
      var _this$setting$开通套餐模块$2 = this.setting.开通套餐模块.套餐模块[this.fromtv ? 'tv' : 'app'],
          vip = _this$setting$开通套餐模块$2.vip,
          svip = _this$setting$开通套餐模块$2.svip;
      var mods = this.isVipTab ? vip : svip;
      return mods;
    },
    // 当前的ptag
    curPtags: function curPtags() {
      var _this = this;

      var APP = PACKAHE_PTAG.APP,
          QQSports = PACKAHE_PTAG.QQSports,
          QQNews = PACKAHE_PTAG.QQNews,
          TV = PACKAHE_PTAG.TV;

      var envPtags = function () {
        if (_this.fromtv) return TV;
        if (env.isQQSports) return QQSports;
        if (env.isQQNews) return QQNews;
        return APP;
      }();

      return envPtags[this.isVipTab ? 'vip' : 'svip'];
    }
  }),
  methods: {
    // 查询是否可开通
    checkOpenAuth: function checkOpenAuth(modId) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, checkRet, checkMsg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (modId) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", true);

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return _this2.magicService.openVipNew({
                  module_id: modId
                }, {
                  silent: false
                });

              case 5:
                res = _context.sent;
                checkRet = res.check_ret, checkMsg = res.check_msg;

                if (!(checkRet === 0)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", true);

              case 9:
                _this2.toast(checkMsg);

                return _context.abrupt("return", false);

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", true);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 13]]);
      }))();
    },
    // 跳转套餐
    handleOpenPackage: function handleOpenPackage(type) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this3$curMods$type, link, 开通模块id, checkRes, ptag, url;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.loginService.isLogin) {
                  _context2.next = 3;
                  break;
                }

                _this3.$openLogin();

                return _context2.abrupt("return");

              case 3:
                _this3$curMods$type = _this3.curMods[type], link = _this3$curMods$type.跳转链接, 开通模块id = _this3$curMods$type.开通模块id;
                _context2.next = 6;
                return _this3.checkOpenAuth(开通模块id);

              case 6:
                checkRes = _context2.sent;

                if (checkRes) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return");

              case 9:
                ptag = _this3.curPtags[type];
                url = buildUrl(link, {
                  ptag: ptag,
                  ru: encodeURIComponent(window.location.href)
                });

                _this3.openUrl(url);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    // 滚动到开通模块
    this.eventBus.$on('scrollToOpen', function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var el = _this4.$refs.modPay;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top;

      window.scroll({
        left: 0,
        top: scrollTop + top
      });
    });
  }
};